import { RequirementConditionType } from 'generated-graphql/types';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';

export const getConversationAutomationScore = (
  analysisAutomationItem: AutomationFormItem
): number => {
  const conversationScoreCondition =
    analysisAutomationItem.requirementConditions.find(
      (condition) =>
        condition.type === RequirementConditionType.ConversationScore
    );

  return conversationScoreCondition?.preferredAnswerScore || 0;
};
